import "../../styles/Banner.css";
//import img from '../../assets/img/restaurante.png'

const Banner = () => {
  
  return (
    <section id="banner">
      <img src={`assets/img/banner.png`} alt="banner"/>
    </section>
  )
}
export default Banner;